import React from 'react';

class PasswordChanger extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isEditing: false,
            password: '',
            confirmation: ''
        };
        this.edit = this.edit.bind(this);
        this.cancel = this.cancel.bind(this);
        this.changePassword = this.changePassword.bind(this);
        this.changeConfirmation = this.changeConfirmation.bind(this);
        this.commit = this.commit.bind(this);
    }

    edit() {
        this.setState({isEditing: true})
    }

    cancel() {
        this.setState({isEditing: false, password: '', confirmation: ''});
    }

    changePassword(event) {
        this.setState({password: event.target.value});
    }

    changeConfirmation(event) {
        this.setState({confirmation: event.target.value});
    }

    commit() {
        this.props.onCommit(this.state.password);
        this.setState({isEditing: false, password: '', confirmation: ''});
    }

    render() {

        const pwValid = (this.state.password !== '') && (this.state.password === this.state.confirmation);

        if (this.state.isEditing) {
            return (
                <div style={{width: '400px'}}>
                    <div className="input-group">
                        <input placeholder="neues Passwort" type="password" value={this.state.password} name="newPassword" className="form-control" onChange={this.changePassword}/>
                        <input placeholder="bestätigen" type="password" value={this.state.confirmation} name="newPassword" className="form-control" onChange={this.changeConfirmation}/>
                        <div className="input-group-btn">
                            <button className="btn btn-success" onClick={this.commit} disabled={!pwValid}><i className="fa fa-check"/>&nbsp;</button>
                            <button className="btn btn-secondary"  onClick={this.cancel}><i className="fa fa-times" />&nbsp;</button>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <button className="btn btn-success" onClick={this.edit}>Passwort ändern</button>
        );
    }
}

export default PasswordChanger;



// WEBPACK FOOTER //
// ./src/admin/user/PasswordChanger.js